// extracted by mini-css-extract-plugin
module.exports = {"content":"BaseBodyText-content-2tFs9xjnqR"};